resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function ModelV2(_model, _handlers, _transferObj) {
    this.constructor = function(_model, _handlers, _transferObj) {
        // In progress
    };

    this.constructor(_model, _handlers, _transferObj);
}